import createReactComponent from '../createReactComponent';
export default createReactComponent('circle-number-0', 'IconCircleNumber0', [
  ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-0' }],
  ['path', { d: 'M10 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0z', key: 'svg-1' }],
]);
